import { ToastContent } from './toast-content'
import { ToastDescription } from './toast-description'
import { ToastDismissButton } from './toast-dismiss-button'
import { ToastPortal } from './toast-portal'
import { ToastProvider } from './toast-provider'
import { ToastRoot } from './toast-root'
import { ToastTitle } from './toast-title'
import { ToastViewport } from './toast-viewport'
import { useToastManager } from './utils'

export const Toast = Object.assign(ToastProvider, {
  Portal: ToastPortal,
  Viewport: ToastViewport,
  Root: ToastRoot,
  Content: ToastContent,
  Title: ToastTitle,
  Description: ToastDescription,
  DismissButton: ToastDismissButton,
  useToastManager,
})
